<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/data/shops/categories')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="shopCategory"
      :rules="rules"
      ref="shopCategoryForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input v-model="shopCategory.name" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/data/shops/categories')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'shopCategoryId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        shopCategory: {},
        rules: {
          name: [
            { required: true, message: 'Név megadása kötelező', trigger: 'change' }
          ]
        }
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Üzlet kategória';
        } else if (this.type === 'update') {
          return 'Üzlet kategória módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['shopCategoryForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('shopCategory/add', this.shopCategory);
              } else if (this.type === 'update') {
                await this.$store.dispatch('shopCategory/update', this.shopCategory);
              }
              this.$store.dispatch('shopCategory/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/data/shops/categories');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if (this.shopCategoryId) {
        this.shopCategory = await this.$store.dispatch('shopCategory/fetch', this.shopCategoryId);
      }
      this.loading = false;
    }
  };
</script>
